<template>
    <div>
        <ModalBase v-model="toggled">
            <template>
                <div class="component c-video-modal flex flex-align-center flex-justify-center">
                    <div class="component c-video-modal__media">
                        <iframe v-if="toggled" class="c-video-modal__video" :src="video" frameborder="0"></iframe>
                    </div>
                </div>
            </template>
        </ModalBase>
    </div>
</template>
<script>
    import ModalBase from '@/components/ModalBase';

    export default {
        name: 'ModalVideo',
        
        components: {
            ModalBase
        },

        props: [
            'value',
            'video'
        ],

        computed: {
            toggled: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },

        watch: {
           toggled: function (newVal) {
                let mp4 = document.getElementById("myVideo");

                // if (!newVal){
                //     mp4.pause();

                //     if (mp4.currentTime === mp4.duration) {
                //         mp4.currentTime = 0;
                //     }
                // }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../styles/imports";
    
    .c-video-modal {background: $black; max-width: 100%; width: 100%;
        &__media {padding-bottom: 56.25%; position: relative; overflow:hidden; width: 100%;}
        &__video {width: 100%; height: 100%; position: absolute; top: 0; left: 0; border: none; z-index: 3;}
    }

    @media screen and (min-width: $large-breakpoint) {
        .c-video-modal {max-width: 75%;}
    }
</style>